module.exports = __webpack_public_path__ + "img/pin_substitution_green.589ddfcb.svg";